/* eslint-disable */
import {Service} from 'components/Shared/server';
import {NotifyMeDto} from 'models/NotifyMeDto';


export const routePostNotifyMeRequest = () => `/api/voyado/notifyme`;
export function postNotifyMeRequest(request: NotifyMeDto): Promise<Response> {
  return Service.post<Response>({
    url: routePostNotifyMeRequest(),
    body: request
  });
}
